import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen">
      <SEO
        title="Privacy Policy - Informativa sulla Privacy"
        description="Informativa sulla privacy di Mangimi Rubini. Scopri come raccogliamo, utilizziamo e proteggiamo i tuoi dati personali secondo il GDPR."
        canonical="/privacy-policy"
      />
      <Navbar />

      <div className="pt-24 pb-16 bg-gray-50">
        <div className="container mx-auto px-4 max-w-4xl">
          <Link to="/" className="inline-block mb-6">
            <Button variant="outline">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Torna alla Home
            </Button>
          </Link>

          <h1 className="text-4xl font-bold mb-8">Privacy Policy</h1>

          <div className="bg-white rounded-lg shadow-sm p-8 space-y-6">
            <section>
              <h2 className="text-2xl font-semibold mb-4">1. Titolare del Trattamento</h2>
              <p className="text-gray-700 leading-relaxed">
                Il Titolare del trattamento dei dati personali è:<br />
                <strong>Mangimi Rubini di Pietro Rubini</strong> (impresa individuale)<br />
                Viale Umbria 21, 06063 Magione (PG)<br />
                P.IVA: 02297550549<br />
                Email: mangimirubini@gmail.com<br />
                Telefono: +39 346 625 7639
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">2. Tipologie di Dati Raccolti</h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                Il sito raccoglie i seguenti dati personali:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li><strong>Dati di navigazione:</strong> indirizzo IP, tipo di browser, sistema operativo, pagine visitate</li>
                <li><strong>Contenuti inseriti nell'assistente virtuale (chatbot):</strong> il testo libero che scrivi nella chat presente in home page viene inviato al nostro fornitore di intelligenza artificiale per generare la risposta (vedi sezione 2-bis)</li>
                <li><strong>Cookie e servizi di terze parti:</strong> come descritto nella nostra Cookie Policy</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">2-bis. Assistente Virtuale (Chatbot AI)</h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                Il sito integra un assistente conversazionale basato su intelligenza artificiale
                (presente in home page). Quando scrivi un messaggio nella chat, il testo che inserisci
                viene trasmesso ai nostri fornitori tecnici per elaborare una risposta automatica:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li><strong>Finalità:</strong> fornire risposte automatiche su prodotti, orari e informazioni commerciali</li>
                <li><strong>Base giuridica:</strong> legittimo interesse a fornire assistenza (art. 6.1.f GDPR); i contenuti liberi che inserisci sono trattati sulla base della tua scelta di utilizzare la chat</li>
                <li><strong>Destinatari:</strong> il messaggio transita tramite l'infrastruttura di <strong>Supabase Inc.</strong> (backend/edge function) e viene inoltrato a <strong>Lovable AB</strong> (AI gateway) che lo elabora tramite il modello <strong>Google Gemini</strong> (Google LLC)</li>
                <li><strong>Natura automatizzata:</strong> le risposte sono generate da un sistema di intelligenza artificiale. Ti invitiamo a <strong>non inserire dati personali</strong> (es. nominativi, recapiti, dati particolari) nella chat</li>
                <li><strong>Conservazione:</strong> i messaggi vengono elaborati per il tempo necessario a generare la risposta; l'eventuale conservazione lato fornitori AI è regolata dalle rispettive policy. Il sito non conserva uno storico persistente delle conversazioni oltre la sessione del browser</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">3. Finalità e Base Giuridica del Trattamento</h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                I tuoi dati personali sono trattati per le seguenti finalità:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li><strong>Rispondere alle richieste tramite l'assistente virtuale:</strong> base giuridica - legittimo interesse (art. 6.1.f GDPR)</li>
                <li><strong>Garantire il funzionamento e la sicurezza del sito:</strong> base giuridica - legittimo interesse (art. 6.1.f GDPR)</li>
                <li><strong>Caricamento di servizi di terze parti (mappa Google Maps):</strong> base giuridica - consenso (art. 6.1.a GDPR)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">4. Modalità del Trattamento</h2>
              <p className="text-gray-700 leading-relaxed">
                I dati personali sono trattati con strumenti informatici e telematici, con logiche strettamente
                correlate alle finalità indicate e con l'adozione delle misure di sicurezza appropriate per
                prevenire perdita, uso illecito o non corretto e accessi non autorizzati.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">5. Conservazione dei Dati</h2>
              <p className="text-gray-700 leading-relaxed">
                I dati personali vengono conservati per il tempo strettamente necessario a conseguire le finalità
                per le quali sono stati raccolti:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2 mt-3">
                <li>Messaggi dell'assistente virtuale: elaborati per il tempo necessario a generare la risposta; nessuno storico persistente è conservato dal sito oltre la sessione del browser. L'eventuale conservazione lato fornitori AI (Lovable/Google) è regolata dalle rispettive policy</li>
                <li>Dati di navigazione e log tecnici di sicurezza (Supabase): per il tempo strettamente necessario alla gestione e sicurezza del servizio</li>
                <li>Cookie e consenso: come specificato nella Cookie Policy (il consenso è conservato fino a 365 giorni)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">6. Comunicazione e Diffusione dei Dati</h2>
              <p className="text-gray-700 leading-relaxed">
                I dati personali non sono oggetto di diffusione. Possono essere comunicati a:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2 mt-3">
                <li><strong>Supabase Inc.</strong> (USA) — hosting del backend, database, autenticazione e edge function; trasferimenti extra-UE regolati da Clausole Contrattuali Standard (SCC)</li>
                <li><strong>Lovable AB</strong> (UE) — piattaforma di hosting del sito e AI gateway per l'assistente virtuale</li>
                <li><strong>Google LLC</strong> (USA) — modello di intelligenza artificiale Gemini (via Lovable) e mappa Google Maps; aderente all'EU-US Data Privacy Framework</li>
                <li>Autorità competenti in caso di obbligo di legge</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">7. Trasferimento Dati Extra-UE</h2>
              <p className="text-gray-700 leading-relaxed">
                Alcuni fornitori hanno sede negli Stati Uniti:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2 mt-3">
                <li><strong>Google LLC</strong> — mappa Google Maps e modello AI Gemini: aderente all'EU-US Data Privacy Framework</li>
                <li><strong>Supabase Inc.</strong> — hosting/backend: trasferimenti garantiti tramite Clausole Contrattuali Standard (SCC), in assenza di certificazione DPF</li>
              </ul>
              <p className="text-gray-700 leading-relaxed mt-3">
                Per l'assistente virtuale (chatbot), i contenuti inseriti transitano tramite Supabase e Lovable e sono elaborati dal modello Google Gemini, come descritto nella sezione 2-bis.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">8. Diritti dell'Interessato</h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                Ai sensi degli articoli 15-22 del GDPR, hai diritto di:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Accedere ai tuoi dati personali</li>
                <li>Ottenere la rettifica o la cancellazione degli stessi</li>
                <li>Limitare il trattamento</li>
                <li>Opporti al trattamento</li>
                <li>Richiedere la portabilità dei dati</li>
                <li>Revocare il consenso in qualsiasi momento</li>
                <li>Proporre reclamo all'Autorità Garante per la protezione dei dati personali (www.garanteprivacy.it — PEC: protocollo@pec.gpdp.it)</li>
              </ul>
              <p className="text-gray-700 leading-relaxed mt-4">
                Per esercitare i tuoi diritti, contattaci via email: <strong>mangimirubini@gmail.com</strong>
              </p>
              <p className="text-gray-700 leading-relaxed mt-4">
                Non è stato nominato un Responsabile della protezione dei dati (DPO) ai sensi
                dell'art. 37 del GDPR, non ricorrendone i presupposti (impresa individuale).
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">9. Modifiche alla Privacy Policy</h2>
              <p className="text-gray-700 leading-relaxed">
                Questa Privacy Policy può essere modificata nel tempo. Ti invitiamo a consultarla periodicamente.
                Ogni modifica sostanziale sarà comunicata tramite avviso sul sito.
              </p>
            </section>

            <section className="border-t pt-6">
              <p className="text-sm text-gray-500">
                Ultimo aggiornamento: 7 luglio 2026
              </p>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
